import { createApp } from 'vue';
import App from './App.vue';
import './assets/scss/app.scss';

createApp(App, {}).mount('#app-puppy');